<script>
	let nyanoAmount
	let nanoAmount
	let nanoInNyanoAmount
	let nyanoInNanoAmount
	let locale = 'en-US'//navigator.language

	let validAmount = new RegExp(/^([\d,]*)(\.?)(\d*)$/)

	$: nyanoAmount && (function () {
		if (!nyanoAmount) {
			nanoInNyanoAmount = convertToNano(1)
		}

		if (validAmount.test(nyanoAmount.toString())) {
			nanoInNyanoAmount = convertToNano(nyanoAmount)
		} else {
			nanoInNyanoAmount = 'Enter valid amount'
		}
	})()

	$: nanoAmount && (function () {
		if (!nanoAmount) {
			nyanoInNanoAmount = convertToNano(1000000)
		}

		if (validAmount.test(nanoAmount.toString())) {
			nyanoInNanoAmount = convertToNyano(nanoAmount)
		} else {
			nyanoInNanoAmount = 'Enter valid amount'
		}
	})()
	
	// -----

	function convertToNyano (nanoAmount) {
		nanoAmount = nanoAmount.toString()
		return 'ɏ' + new Decimal(stripCommas(decimalPointCheck(nanoAmount))).mul(1000000).toNumber().toLocaleString(locale)
	}

	// -----

	function convertToNano (nyanoAmount) {
		nyanoAmount = nyanoAmount.toString()
		return 'Ӿ' + new Decimal(stripCommas(decimalPointCheck(nyanoAmount))).div(1000000).toNumber().toLocaleString(locale, {minimumFractionDigits: 0, maximumFractionDigits: 6})
	}
	
	// -----

	function decimalPointCheck (amount) {
		if (amount.startsWith('.')) {
			return '0' + amount
		}
		return amount
	}
	
	// -----

	function stripCommas (amount) {		
		return amount.replace(/,/g, '')
	}	

</script>

<main>
	<h1>Nyano / Nano Calculator</h1>
	<p>Convert between nyano (ɏ) and nano (Ӿ) amounts</p>
	<div class="calculator">
		<div class="row">
			<div class="left">
				<img src="./nyano-logo.png" class="logo"/>
				ɏ <input type="text" bind:value={nyanoAmount} placeholder="1"/>
			</div>
			<div class="right">
				= <span class="amount">{nyanoAmount ? nanoInNyanoAmount : (convertToNano(1))}</span> <img src="./nano-logo.png" class="logo"/>
			</div>
		</div>
		<div class="row">
			<div class="left">
				<img src="./nano-logo.png" class="logo" />
				Ӿ <input type="text" bind:value={nanoAmount}  placeholder="1"/>
			</div>
			<div class="right">
				= <span class="amount">{nanoAmount ? nyanoInNanoAmount : (convertToNyano(1))}</span> <img src="./nyano-logo.png" class="logo"/>
			</div>
		</div>
	</div>
	<footer>
		<div>
			Links: <a href="https://nyano.org">nyano.org</a> | <a href="https://nano.org">nano.org</a>
		</div>		
		<div>
			Site provided by <a href="https://nanocharts.info">NanoCharts</a>
		</div>
	</footer>	
</main>

<style>
	main {
		text-align: center;
		padding: 1em;		
		margin: 0 auto;
		font-size: 2rem;
		font-family: "Nunito", "Helvetica Neue", Helvetica, Arial, sans-serif;	
	}

	main p {
		font-size: 1.5rem;
		margin: 0 0 2rem 0;
		color: #00000090;
	}	

	h1 {
		color: #4A90E2;
		font-size: 2em;
		font-weight: 100;
		margin: 0;
	}

	input {
		font-size: 1em;
		font-weight: 100;
		font-family: "Nunito", "Helvetica Neue", Helvetica, Arial, sans-serif;	
		width: 200px;
		margin-right: 1rem;
	}	

	footer {
		font-size: 1rem;
		margin-top: 7rem;
	}

	footer div:first-child {		
		margin-bottom: 1rem;
	}	

	a, a:visited {
		color: #4A90E2;
		font-weight: bold;
	}

	.calculator {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.logo {
		width: 50px;
		padding: 0 1rem;
	}

	.amount {
		margin-left: 1rem;
		font-weight: bold;
	}

	.row {
		display: flex;
		align-items: center;
		margin: 2.7rem 0;
	}

	.left, .right {
		display: flex;
		align-items: center;		
		white-space: nowrap;
	}

	.right {
		margin-left: 1rem;
	}	

	@media (max-width: 750px) {
		main {
			max-width: none;
			font-size: 1.2rem;
		}

		input {
			font-size: 1em;
			font-weight: 100;
			font-family: "Nunito", "Helvetica Neue", Helvetica, Arial, sans-serif;	
			width: 120px;
			margin-right: 1rem;
		}

		.row {
			flex-direction: column;
		}

		.right {
			margin-top: 0.5rem;
		}		
		
	}
</style>